/*
 * File: CustomSeperator.tsx
 * Project: a-a
 * File Created: Wednesday, 9th October 2024 12:32:44 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Sunday, 27th October 2024 12:35:51 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import zeplinColor from '../../../theme/Color';
import './CustomSeperator.css';

const CustomSeperator = ({
  text,
  style,
}: {
  text: string;
  style?: React.CSSProperties | undefined;
}) => {
  return (
    // <>
    //     <div style={style ? {...style}:{}}>sss</div>
    //     <p style={{color:zeplinColor.Neutral9}}>{text}</p>
    //     <div style={style ? {...style}:{}}></div>
    // </>
    <div className='separator' style={style ? { ...style } : {}}>
      <span>{text}</span>
    </div>
  );
};

export default CustomSeperator;
